import { RiHotspotLine } from "react-icons/ri";
import "../assets/css/Sidebar.css";
import { useLocation } from "react-router-dom";
import QuickStatus from "./Quickstatus";

const Sidebar = ({ onSelect, alertView }) => {
  const location = useLocation();
  const locationName = location.state?.locationName || "Ethiopia";
  const [key, value] = locationName.includes(":") ? locationName.split(":") : ["", locationName];
  const displayKey = key
    ? key
        .replace(/([A-Z])/g, ' $1')    // insert space before uppercase letters
        .trim()                       // remove leading/trailing spaces
        .replace(/\b\w/g, c => c.toUpperCase()) // capitalize first letter of each word
    : "";

  // If displayKey is e.g. “RegionalState”, this becomes “Regional State”
  const displayText = displayKey
  ? `${displayKey} : ${value}`
  : value;
  return (
    
    <aside className="sidebar-container">
      <div className="sidebar-content">
        {/* Navigation Section */}
        <div>
          <h2 className="nav-section__title">{displayText}</h2>
          <ul className="nav-list">
            <li>
              <button
                className={`nav-button ${
                  alertView === "disease-hotspot" ? "active" : ""
                }`}
                onClick={() => onSelect?.("disease-hotspot")} 
              >
                <div className="nav-button__inner">
                  <RiHotspotLine className="icon" />
                  <span className="text">Disease Hotspot</span>
                </div>
              </button>
            </li>
          </ul>
        </div>

        {/* Quick Status Section */}
       <QuickStatus alertView={alertView} />
      </div>
    </aside>
  );
};

export default Sidebar;

